<template>
  <div class="code-block">
    <div v-if="block.language" class="code-lang">
      <q-icon name="code" size="14px" />
      <span>{{ block.language }}</span>
    </div>
    <pre class="code-pre"><code>{{ block.code }}</code></pre>
  </div>
</template>

<script setup lang="ts">
interface CodeBlock {
  type: 'code';
  language?: string;
  code: string;
}

defineProps<{ block: CodeBlock }>();
</script>

<style scoped lang="scss">
.code-block {
  margin: 24px 0;
  border-radius: var(--oa-radius-lg);
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--oa-border) 60%, transparent);
  background: var(--oa-bg-1);
}

.code-lang {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--oa-bg-3);
  padding: 8px 14px;
  font-size: var(--oa-text-xs);
  font-family: var(--oa-font-mono);
  color: var(--oa-gold-full);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  border-bottom: 1px solid color-mix(in srgb, var(--oa-border) 50%, transparent);
}

.code-pre {
  padding: 18px 20px;
  margin: 0;
  overflow-x: auto;
  font-family: var(--oa-font-mono);
  font-size: var(--oa-text-sm);
  line-height: 1.65;
  color: var(--oa-text-primary);
}
</style>
